import { render, staticRenderFns } from "./deleteApplyRoomDiscountType.vue?vue&type=template&id=8f5e2b0e&scoped=true"
import script from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
export * from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyRoomDiscountType.vue?vue&type=style&index=0&id=8f5e2b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e2b0e",
  null
  
)

export default component.exports